import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	versions: {
		id: 'software-deployments.top-filters.versions-filter.versions',
		defaultMessage: 'Versions',
		description: 'Label for the versions filter above the deployments view',
	},
});
